

// import React from 'react';
// import image1 from '../assets/Motocross.jpg'; // Replace with the path to your first image
// import image2 from '../assets/Motocross.jpg'; // Replace with the path to your second image

// const FranchiseOwners = () => {
//   return (
//     <div className="bg-gradient-to-b from-[#FF9630] to-orange-300 py-10">
//       <h2 className="text-center text-white text-3xl font-semibold mb-6">
//         Our Happy Franchise Owners
//       </h2>
//       <div className="flex flex-col md:flex-row justify-center md:space-x-8 space-y-6 md:space-y-0 w-full mx-auto p-4">
        
//         {/* First Image Block */}
//         <div className="w-full  md:w-1/3 h-64 bg-gray-200 rounded-lg overflow-hidden shadow-lg"> {/* Adjusted width for mobile */}
//           <img src={image1} alt="Franchise Owner 1" className="w-full h-full object-cover" />
//         </div>
        
//         {/* Second Image Block */}
//         <div className="w-full md:w-1/3 h-64 bg-gray-200 rounded-lg overflow-hidden shadow-lg"> {/* Adjusted width for mobile */}
//           <img src={image2} alt="Franchise Owner 2" className="w-full h-full object-cover" />
//         </div>
        
//       </div>
//     </div>
//   );
// };

// export default FranchiseOwners;


import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';

// Import your images
import image1 from '../assets/Motocross.jpg';
import image2 from '../assets/Motocross.jpg'; // Replace with a different image

const FranchiseOwners = () => {
  return (
    <div className="bg-gradient-to-b from-[#FF9630] to-orange-300 py-10">
      <h2 className="text-center text-white text-3xl font-semibold mb-6">
        Our Happy Franchise Owners
      </h2>
      {/* Mobile View - Swiper Carousel */}
      <div className="md:hidden w-full mx-auto p-4">
        <Swiper
          spaceBetween={16}
          pagination={{ clickable: true }}
          modules={[Pagination]}
        >
          <SwiperSlide>
            <div className="h-64 bg-gray-200 rounded-lg overflow-hidden shadow-lg">
              <img src={image1} alt="Franchise Owner 1" className="w-full h-full object-cover" />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="h-64 bg-gray-200 rounded-lg overflow-hidden shadow-lg">
              <img src={image2} alt="Franchise Owner 2" className="w-full h-full object-cover" />
            </div>
          </SwiperSlide>
        </Swiper>
      </div>

      {/* Desktop View - Side-by-Side Images */}
      <div className="hidden md:flex justify-center md:space-x-8 w-full mx-auto p-4">
        <div className="w-full md:w-1/3 h-64 bg-gray-200 rounded-lg overflow-hidden shadow-lg">
          <img src={image1} alt="Franchise Owner 1" className="w-full h-full object-cover" />
        </div>

        <div className="w-full md:w-1/3 h-64 bg-gray-200 rounded-lg overflow-hidden shadow-lg">
          <img src={image2} alt="Franchise Owner 2" className="w-full h-full object-cover" />
        </div>
      </div>
    </div>
  );
};

export default FranchiseOwners;
